// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminPanelLayout_admin_panel_container__kBUMW {
  display: flex;
  background-color: var(--main-bg-color);
  overflow: hidden;
}
.adminPanelLayout_admin_panel_container__kBUMW .adminPanelLayout_main_part__KbROz {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
}
.adminPanelLayout_admin_panel_container__kBUMW .adminPanelLayout_main_part__KbROz .adminPanelLayout_header_wrap__1H6qA {
  display: flex;
  position: sticky;
  align-items: center;
  height: var(--admin-header-height);
  top: 0;
  z-index: 10;
  padding: 10px;
  border-bottom: 1px solid var(--border-default-color);
  background-color: #ffffff;
}
@media (max-width: 991px) {
  .adminPanelLayout_admin_panel_container__kBUMW .adminPanelLayout_main_part__KbROz .adminPanelLayout_header_wrap__1H6qA {
    height: var(--admin-header-height-less);
  }
}

.adminPanelLayout_confirmation_description__-0WIm {
  margin-top: 10px;
  font-size: 16px;
  line-height: 24px;
  color: #4e575f;
  max-width: 500px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/AdminPanel/AdminPanelLayout/adminPanelLayout.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sCAAA;EACA,gBAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,oDAAA;EACA,yBAAA;AACH;AAGC;EAEE;IACC,uCAAA;EAFF;AACF;;AAOA;EACC,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAJD","sourcesContent":[".admin_panel_container {\n display: flex;\n background-color: var(--main-bg-color);\n overflow: hidden;\n\n .main_part {\n  width: 100%;\n  height: 100vh;\n  overflow-x: hidden;\n\n  .header_wrap {\n   display: flex;\n   position: sticky;\n   align-items: center;\n   height: var(--admin-header-height);\n   top: 0;\n   z-index: 10;\n   padding: 10px;\n   border-bottom: 1px solid var(--border-default-color);\n   background-color: #ffffff;\n  }\n }\n\n @media (max-width: 991px) {\n  .main_part {\n   .header_wrap {\n    height: var(--admin-header-height-less);\n   }\n  }\n }\n}\n\n.confirmation_description {\n margin-top: 10px;\n font-size: 16px;\n line-height: 24px;\n color: #4e575f;\n max-width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"admin_panel_container": `adminPanelLayout_admin_panel_container__kBUMW`,
	"main_part": `adminPanelLayout_main_part__KbROz`,
	"header_wrap": `adminPanelLayout_header_wrap__1H6qA`,
	"confirmation_description": `adminPanelLayout_confirmation_description__-0WIm`
};
export default ___CSS_LOADER_EXPORT___;
